import keyBy from 'lodash/keyBy';
import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  attachments: {},
  attachmentsByChannelId: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.BUZZ__LOADED_ATTACHMENTS: {
      const channelId = action.payload.channelId;

      // Add natural key to attachments because attachment.id is not unique across messages
      const attachments = action.payload.attachments.map(attachment => ({
        ...attachment,
        key: `${attachment.messageId}${attachment.id}`,
      }));
      const attachmentsById = keyBy(attachments, 'key');
      const byChannelId = attachments.reduce(
        (memo, attachment) => memo.add(attachment.key),
        new Set(state.attachmentsByChannelId[channelId])
      );

      return {
        attachments: {
          ...state.attachments,
          ...attachmentsById,
        },
        attachmentsByChannelId: {
          ...state.attachmentsByChannelId,
          [channelId]: byChannelId,
        },
      };
    }

    default: {
      return state;
    }
  }
};
